import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import th from './locales/th.json';
import si from './locales/si.json';
import bn from './locales/bn.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷', locale: 'fr-FR' },
  { code: 'en', label: 'English', flag: '🇬🇧', locale: 'en-GB' },
  { code: 'th', label: 'ภาษาไทย', flag: '🇹🇭', locale: 'th-TH' },
  { code: 'si', label: 'සිංහල', flag: '🇱🇰', locale: 'si-LK' },
  { code: 'bn', label: 'বাংলা', flag: '🇧🇩', locale: 'bn-BD' },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export function getDateLocale(lang: string): string {
  const found = SUPPORTED_LANGUAGES.find((l) => l.code === lang);
  return found?.locale ?? 'fr-FR';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      th: { translation: th },
      si: { translation: si },
      bn: { translation: bn },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'th', 'si', 'bn'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'haccp_lang',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
